const constants = {
  API_URL: process.env.NODE_ENV === 'production' ? 'https://staging.grouphug.online/api' : 'http://localhost:3300/api',

  // Subsidy model 2026: show new UI (per-pair session count, etc.) from this date.
  // Change to a past date to test, future date to disable.
  SUBSIDY_2026_START: new Date('2026-05-10T21:00:00.000Z'), // = 20.05.2026 00:00 Israel

  // Feature flag: allow experts to convert a 1TO1 service into a series in the
  // edit dialog. Flip to false to hide the toggle without removing the code.
  ENABLE_SERIES_EDITING: false,
};

export default constants;
